import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type XpMessageSeverity = 'success' | 'error' | 'info' | 'warning';

const SEVERITY_ICONS: Record<XpMessageSeverity, string> = {
	success: 'check_circle',
	error: 'error',
	info: 'info',
	warning: 'error_outline'
};

@Component({
	selector: 'xp-message',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './xp-message.component.html',
	styleUrls: ['./xp-message.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpMessageComponent {
	severity = input<XpMessageSeverity>('info');
	icon = input<string | null>(null);
	plain = input(false);

	shownIcon = computed(() => this.icon() ?? SEVERITY_ICONS[this.severity()]);

	@HostBinding('attr.data-ui-severity')
	get severityAttribute(): XpMessageSeverity {
		return this.severity();
	}

	@HostBinding('class.xp-message--plain')
	get isPlain(): boolean {
		return this.plain();
	}
}
